import script from "./stockAllocationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./stockAllocationTable.vue?vue&type=script&setup=true&lang=js"

import "./stockAllocationTable.vue?vue&type=style&index=0&id=24f23e4b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f23e4b"]])

export default __exports__